import React from "react";
import { Col } from "react-bootstrap";
import SectionWrapper from "components/layout/section_wrapper";
import RatesTable from "components/rates_table";

export default function HotelRatesSection({
  property = {},
  bookedRooms,
  update,
  disable,
  bookedRatesOccupancy,
  setShowLoginModal,
  isMemberShipEnabled,
}) {
  return (
    <div className=" ">
      <SectionWrapper id="hotel_rates_section" theme="dark">
        <Col>
          <RatesTable
            isMemberShipEnabled={isMemberShipEnabled}
            setShowLoginModal={setShowLoginModal}
            property={property}
            bookedRooms={bookedRooms}
            update={update}
            disable={disable}
            bookedRatesOccupancy={bookedRatesOccupancy}
          />
        </Col>
      </SectionWrapper>
    </div>
  );
}
